import axios from "axios";

export const state = {
    withdrawcharges: [],
};

export const getters = {
    withdrawcharges: state => state.withdrawcharges,
};

export const mutations = {
    setWithdrawCharges(state, newValue) {
        state.withdrawcharges = newValue
    },
};

export const actions = {
    async fetchWithdrawCharges({ commit }) {
        await axios.get('/withdrawcharges').then(res => {
            commit('setWithdrawCharges', res.data.withdrawcharges)
        })
    },
    async filterWithdrawCharges({commit}, {datefrom,dateto}) { 
        let formData = new FormData();
        formData.append("datefrom", datefrom);
        formData.append("dateto", dateto);
        let url = "/filterwithdrawcharges";
        await axios.post(url, formData).then((response) => {
            commit('setWithdrawCharges', response.data.withdrawcharges)
        })
    },
};
